// TODO(olha): WIP Editor it's temporary. will be removed after merging Editor
import { marked } from 'marked';
import { Message, SearchWebPageReference } from 'src/types';
import { CITATION_REGEX_WITHOUT_SPACE } from 'src/constants';
import {
  getTextContentFromMessage,
  getWebPageReferencesFromMessage,
} from 'src/utils';

marked.setOptions({
  breaks: true,
});

export const buildFootnotesMarkdown = (
  footnotes: SearchWebPageReference[],
): string => {
  return footnotes.reduce((md, footnote, i) => {
    const index = i + 1;
    const safeUrl = footnote.url ?? '#';
    const displayTitle = footnote.title || `Footnote #${index}`;

    return `${md}\n\n${index}.[${displayTitle}](${safeUrl})`;
  }, '\n\n\n---\n');
};

export const buildFullMarkdown = ({
  markdown,
  footnotes,
}: {
  markdown: string;
  footnotes?: SearchWebPageReference[];
}): string => {
  const fullMarkdown =
    footnotes && footnotes.length > 0
      ? `${markdown}${buildFootnotesMarkdown(footnotes)}`
      : markdown;

  return fullMarkdown;
};

export const getDocumentContentFromMessage = ({
  message,
  activeTab,
}: {
  message?: Message;
  activeTab: string;
}) => {
  const content = getTextContentFromMessage({
    message,
    activeTab,
  });

  const footnotes = getWebPageReferencesFromMessage({
    message,
    activeTab,
  });

  const processedContent = content.replace(
    CITATION_REGEX_WITHOUT_SPACE,
    (_, num: number) =>
      `[[${num}]](${footnotes?.[num - 1].url || 'about:blank'})`,
  );

  return {
    markdown: processedContent,
    footnotes,
  };
};

export const buildFullMarkdownFromMessage = ({
  message,
  activeTab,
}: {
  message?: Message;
  activeTab: string;
}) => {
  const { markdown, footnotes } = getDocumentContentFromMessage({
    message,
    activeTab,
  });

  const fullMarkdown = buildFullMarkdown({ markdown, footnotes });
  return fullMarkdown;
};

// TODO(olha): temporary until Editor is done
export const convertMarkdownToHTMLString = async (markdown: string) => {
  return marked.parse(markdown);
};
